var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('PerDialog',{attrs:{"config":_vm.config},on:{"closePerDialog":_vm.closePerDialog,"confirmPerDialog":_vm.confirmPerDialog,"before-close":_vm.closePerDialog}})}
var staticRenderFns = []

export { render, staticRenderFns }